import { Injectable, signal } from '@angular/core';
import { OrganizationModel, OrganizationScheduleMapping, OrganizationScheduleMappingStatus } from '../shared/models/organization.model';

@Injectable({ providedIn: 'root' })
export class OrganizationStore {
  private readonly _organizations = signal<OrganizationModel[]>([]);
  private readonly _selectedOrganization = signal<OrganizationModel | null>(null);
  private readonly _selectedScheduleMapping = signal<OrganizationScheduleMapping | null>(null);
  private readonly _scheduleMappingStatuses = signal<OrganizationScheduleMappingStatus[]>([]);

  readonly organizations = this._organizations.asReadonly();
  readonly selectedOrganization = this._selectedOrganization.asReadonly();
  readonly selectedScheduleMapping = this._selectedScheduleMapping.asReadonly();
  readonly scheduleMappingStatuses = this._scheduleMappingStatuses.asReadonly();

  setOrganizations(orgs: OrganizationModel[]) {
    this._organizations.set([...orgs]);
  }

  setSelected(org: OrganizationModel | null) {
    this._selectedOrganization.set(org);
  }

  setSelectedScheduleMapping(scheduleMapping: OrganizationScheduleMapping | null) {
    this._selectedScheduleMapping.set(scheduleMapping);
  }

  setScheduleMappingStatuses(statuses: OrganizationScheduleMappingStatus[]) {
    this._scheduleMappingStatuses.set([...statuses]);
  }

  addOrganization(org: OrganizationModel) {
    this._organizations.update((orgs) => [...orgs, org]);
  }

  updateOrganization(updated: OrganizationModel) {
    this._organizations.update((orgs) =>
      orgs.map((org) => (org.id === updated.id ? updated : org))
    );
  }

  removeOrganization(id: Guid) {
    this._organizations.update((orgs) => orgs.filter((org) => org.id !== id));
  }
}
